module.exports = __webpack_public_path__ + "static/media/24UHCHR3.02d79008.jpg";